import React from 'react';
import "./style.scss"
import utilsFunction from "../../../../utils/utilsFunction";
import numericFunction from "../../../../utils/NumericFunction";
import {formatToPersianAddComma} from "../../../../utils/CommaSeparator";

function AnipoPrint3(props) {

  const data = props.data
  //console.log(data)
  let totalSum = 0;

  return (<div className={"Anipo__Print3__style text-end"}>
    <div className={"print__container "}>
      <div className={"print__data w-100"}>
        <div className={" a5__size__cutMargin"}>
          <div className={"d-flex"}>
            <div className={"borderLeft__anipo__print  half__a5__size__cutMargin"}>
              <div className={"fw-bold text-end"}>  {data.destination.province} {data.destination.city}</div>
              <div className={"w-100 height__4cm text-justify"}>
                گیرنده:
                {data.destination.address}
              </div>
              <div className={"text-end"}>
                نام و نام خانوادگی:

                {data.destination.name}
              </div>
              <div className={"text-end"}>
                شماره تماس:
                &nbsp;
                {numericFunction.e2p(data.destination.callNumber)}
              </div>
            </div>
            <div className={" borderLeft__anipo__print half__a5__size__cutMargin"}>
              <div className={"fw-bold text-end d-flex justify-content-between"}>
                <div className={"shopName_OrderId"}>
                  <div className={""}>{data.source.shopName}</div>
                  <div className={"font__size__10 mt-1"}> کد سفارش: {numericFunction.e2p(data.orderId)}</div>
                </div>
                <div className={"logo__section"}>{data?.logo && <img src={data?.logo}/>}</div>
              </div>
              <div className={"text-end"}>{data.source.province} {data.source.city}</div>

              <div className={"w-100 height__3cm text-justify"}>
                فرستنده:
                {data.source.address}
              </div>
              <div className={"text-end"}>
                نام و نام خانوادگی:

                {data.source.name}
              </div>
              <div className={"text-end"}>
                شماره تماس:
                &nbsp;
                {numericFunction.e2p(data.source.callNumber)}
              </div>
              <div className={"text-end"}>
                وب سایت:
                &nbsp;
                {(data.source.site)}
              </div>
            </div>
          </div>

        </div>
      </div>
      {data?.products?.length > 0 && <>

        <table className={""}>
          <thead>
          <tr className={"bg-white"}>
            <th className={"text-center"}>ردیف</th>
            <th className={"text-center"}>نام محصول</th>
            <th className={"text-center"}>قیمت</th>
            <th className={"text-center"}>وزن</th>
            <th className={"text-center"}>جمع</th>
          </tr>
          </thead>
          <tbody>
          {data.products.map((item, index) => {
            const sumOfRow = (+item.weight) * (+item.price)
            totalSum = totalSum + sumOfRow
            return <>
              <tr className={"bg-white"}>
                <td className={"text-center"}>{numericFunction.e2p(index+1)}</td>
                <td className={"text-center"}>{item.name}</td>
                <td className={"text-center"}>{formatToPersianAddComma(item.price)}</td>
                <td className={"text-center"}>{numericFunction.e2p(item.weight)}</td>
                <td className={"text-center"}>{formatToPersianAddComma(sumOfRow)}</td>
              </tr>

            </>
          })}

          <tr className={"bg-white"}>
            <th className={"text-center"}>جمع مبلغ</th>
            <th className={"text-center"}></th>
            <th className={"text-center"}></th>
            <th className={"text-center"}></th>
            <th className={"text-center"}>{formatToPersianAddComma(totalSum)}</th>
          </tr>
          </tbody>
        </table>


      </>}

    </div>
  </div>);
}

export default AnipoPrint3;